import React, { ReactNode } from "react";
import styled from "styled-components/macro";
import { theme } from "ui/theme";

import { GuestLayoutFooter } from "components/Footer";
import Header from "components/Header";

export interface GuestLayoutProps {
  children: ReactNode;
  userType: "teacher" | "student";
  showCreateAccount?: boolean;
  backButton?: ReactNode;
  showSignout?: boolean;
}

const $PageWrapper = styled.div`
  background-color: ${theme.ColorBlurple500};
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

const $ChildrenWrapper = styled.div`
  background-color: white;
  text-align: center;
  margin: 5rem 2rem;
  border-radius: 1rem;
  padding-top: 2rem;

  width: 45rem;
  @media screen and (${theme.BreakpointTabletDown}) {
    width: fit-content;
  }
`;

/**
 * Background for non-logged in guest users
 */
export default function GuestLayout({
  children,
  userType,
  showCreateAccount = false,
  backButton,
  showSignout = true,
}: GuestLayoutProps) {
  return (
    <$PageWrapper>
      {userType === "student" && (
        <Header showSignout={showSignout} backButton={backButton} />
      )}
      <$ChildrenWrapper>{children}</$ChildrenWrapper>
      <GuestLayoutFooter
        userType={userType}
        showCreateAccount={showCreateAccount}
        isOnDarkBackground
      />
    </$PageWrapper>
  );
}
